/**
 * Returns true when a keyboard event matches the life-space switcher combo
 * (Cmd/Ctrl + Alt + ArrowUp/Down) and therefore must be ignored by list
 * navigation handlers.
 *
 * Without this guard, pressing Cmd+Alt+ArrowUp on macOS (to switch life space
 * upwards) would also match the inner list's "Cmd+ArrowUp = jump to top"
 * shortcut in useProjectNavigation, marking the first section in the new
 * life space's project as soon as the switch lands.
 */
export function isLifeSpaceSwitchCombo(
  e: { key: string; altKey: boolean; metaKey: boolean; ctrlKey: boolean },
): boolean {
  if (!e.altKey) return false
  if (!e.metaKey && !e.ctrlKey) return false
  return e.key === 'ArrowUp' || e.key === 'ArrowDown'
}
